import { render, staticRenderFns } from "./GradeViewer.vue?vue&type=template&id=205e2bfe&"
import script from "./GradeViewer.vue?vue&type=script&lang=ts&"
export * from "./GradeViewer.vue?vue&type=script&lang=ts&"
import style0 from "./GradeViewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports